import React from 'react'
export const Notifications = () => {
    const data = [
        {
            name: "New User Joined",
        },
        {
            name: "Change Password",
        },
        {
            name: "Blocked Users",
        },
    ]
    return (
        <>
            <div className='p-sm-3'>
                <div>
                    <h3 className='fw-bold'>Notifications</h3>
                    <div className="row">
                        <div className="col-md-6">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste corrupti nisi beatae, fugit amet veniam ipsa atque dolore placeat excepturi?</p>
                        </div>
                    </div>
                    <div className="w-100 d-flex flex-column gap-3">
                        {
                            data?.map((e) => (
                                <div className="rounded-4 p-3" style={{ backgroundColor: "#F0F6FF", border: "2px solid #DFE9F7" }}>
                                    <div className='d-flex justify-content-end '>
                                        {/* <span className='text-white p-2 px-3 rounded-2 text-center' style={{ backgroundColor: e.name=='New User Joined'? '#14B842' : e.name=='Change Password'? '#FBB142' : e.name=='Blocked Users'? '#E24077': '#14B842' }}> {e.name}</span> */}
                                        <small className='text-gray'>29 Jan 2024 at 9:30 AM</small>
                                    </div>
                                    <div className="d-flex flex-sm-row flex-column  align-items-sm-center gap-3">
                                        <div className='d-flex align-items-end'>
                                            <div className='bg-white d-flex align-items-center rounded-3 p-2'>
                                                <img src={require('../assets/basil_notification-on-outline.png')} alt="" style={{ width: "35px", height: "35px", objectFit: "cover" }} />
                                            </div>
                                        </div>
                                        <div>
                                            <h6 className='fw-bold'>Notification</h6>
                                            <small className='text-gray'>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. </small>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
